module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_500_750.04561054.png";